// extracted by mini-css-extract-plugin
export default {"image":"LoginImage_image__P0EDx"};